'use strict';
//remplacement d'image
if (window.matchMedia("(min-width: 650px)").matches) {
  window.addEventListener('scroll', e => {
    if (scrollY >= 35) {
      logo.classList.add('header__logo--litle');
      header.classList.add('header--fixed');
    } else {
      logo.classList.remove('header__logo--litle');
      header.classList.remove('header--fixed');
    }
  });
}
//animation au scroll
let ratio = .3;
let options = {
  root: null,
  rootMargin: '0px',
  threshold: ratio
}
let afficher = function (entries, observer) {
  entries.forEach(entry => {
    if (entry.intersectionRatio > ratio) {
      entry.target.classList.add('reveal--on');
      observer.unobserve(entry.target);
      let link = document.querySelector('.link');
      let list = document.querySelector('.list__resel');
      let svg = document.querySelectorAll('.svg--anim');
      if (entry.target == list) {
        let i = 100;
        svg.forEach(e => {
          setTimeout(function () {
            e.style.animationName = "anim-svg";
          }, i);
          i = i + 400;
        });
      }
      if (window.matchMedia("(min-width: 550px)").matches) {
        if (entry.target == link) {
          setTimeout(function () {
            link.classList.add('link--hover');
          }, 1000);
        }
      }
    }
  });
}

var observer = new IntersectionObserver(afficher, options);
let reveal = document.querySelectorAll('[class*="reveal-"]');
reveal.forEach((e) => {
  observer.observe(e);
});

setTimeout(function () {
  let list_essai = document.querySelector('.list__essai');
  list_essai.classList.add('anim__essai');
}, 6000);

let logo = document.querySelector('.header__logo');
let header = document.querySelector('.header');
